<template>
  <div id="ag-grid-demo">
    <div id="div-with-loading" class="vs-con-loading__container">
      <!-- Tabs on the top -->
      <vs-tabs
        v-if="favouriteClients.length"
        id="fav-client-tabs"
        class="custom-vs-tabs clients-page slot-border-top"
      >
        <vs-tab
          v-for="(favClient, index) in favouriteClients"
          :key="
            favClient.unique_registrar
              ? `favClient-${favClient.unique_registrar_id}`
              : `favClient-${favClient.new_reseller_id}`
          "
          :label="
            favClient.unique_registrar_id
              ? favClient.unique_registrar.name + '-' + favClient.unique_registrar.cnic_id
              : favClient.new_reseller.name
          "
          :data="fav_client_ids"
          @click="switchToTabs()"
        >
          <div class="tab-text">
            <div class="expiring-promo-count flex mx-5">
              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiringInAWeekPromos(
                    favClient.unique_registrar_id
                      ? favClient.unique_registrar_id
                      : favClient.reseller_id,
                    favClient.unique_registrar_id ? 'registrar' : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-week
                  "
                  style="background: rgba(var(--vs-warning), 0.1)"
                  >{{ favClient.expiringInAWeekCount }}</small
                >
                <div class="text-center">
                  <strong> Expiring in a week </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiringInTwoWeeksPromos(
                    favClient.unique_registrar_id
                      ? favClient.unique_registrar_id
                      : favClient.reseller_id,
                    favClient.unique_registrar_id ? 'registrar' : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-two-weeks
                  "
                  style="background: rgba(var(--vs-primary), 0.1)"
                  >{{ favClient.expiringInTwoWeeksCount }}</small
                >
                <div class="text-center">
                  <strong> Expiring in two weeks </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiredPromos(
                    favClient.unique_registrar_id
                      ? favClient.unique_registrar_id
                      : favClient.reseller_id,
                    favClient.unique_registrar_id ? 'registrar' : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expired
                  "
                  style="background: rgba(var(--vs-danger), 0.1)"
                  >{{ favClient.expiredCount }}</small
                >
                <div class="text-center"><strong> Expired </strong></div>
              </div>

              <div
                class="
                  mx-5
                  py-5
                  text-center
                  reset-filter
                  expiring-promo-count--action-btn
                "
                @click="resetFilters()"
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    reset-icon
                  "
                  style="background: rgba(var(--vs-primary), 0.1)"
                >
                  <strong
                    ><feather-icon
                      icon="RotateCwIcon"
                      :svgClasses="`h-4 w-4 mt-1`"
                  /></strong>
                </small>
                <div class="text-center reset-text">
                  <strong> Reset </strong>
                </div>
              </div>

              <div class="py-5 ml-auto justify-center flex items-center">
                <vs-button
                  color="primary"
                  type="filled"
                  class="action-btn mr-3"
                  @click="addAgreements(fav_client_ids[index])"
                  >Add Agreement</vs-button
                >
                <vs-button
                  color="primary"
                  type="border"
                  class="action-btn"
                  @click="viewAgreements(fav_client_ids[index])"
                  >View Agreements</vs-button
                >
              </div>
            </div>
            <vs-collapse>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">CNIC Promos</div>
                <CnicPromoClientComponent
                  :registrarid="
                    favClient && favClient.unique_registrar
                      ? favClient.unique_registrar.id
                      : null
                  "
                  :filteredData="filteredCNICData"
                ></CnicPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">
                  Internal Promos
                </div>
                <InternalPromoClientComponent
                  :resellerid="
                    favClient && favClient.reseller
                      ? favClient.reseller.id
                      : null
                  "
                  :filteredData="filteredInternalData"
                ></InternalPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">MIS</div>
                <MisPromoClientComponent
                  :resellerid="
                    favClient && favClient.reseller
                      ? favClient.reseller.id
                      : null
                  "
                  :filteredData="filteredMISData"
                ></MisPromoClientComponent>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>

        <vs-tab label="" id="clients-tab">
          <div class="tab-text">
            <div class="expiring-promo-count flex mx-5">
              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiringInAWeekPromos(
                    selected_from_all_clients.registrar_id
                      ? selected_from_all_clients.registrar_id
                      : selected_from_all_clients.reseller_id,
                    selected_from_all_clients.registrar_id
                      ? 'registrar'
                      : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-week
                  "
                  style="background: rgba(var(--vs-warning), 0.1)"
                  >{{ selected_from_all_clients.expiringInAWeekCount }}</small
                >
                <div class="text-center">
                  <strong> Expiring in a week </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiringInTwoWeeksPromos(
                    selected_from_all_clients.registrar_id
                      ? selected_from_all_clients.registrar_id
                      : selected_from_all_clients.reseller_id,
                    selected_from_all_clients.registrar_id
                      ? 'registrar'
                      : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-two-weeks
                  "
                  style="background: rgba(var(--vs-primary), 0.1)"
                  >{{
                    selected_from_all_clients.expiringInTwoWeeksCount
                  }}</small
                >
                <div class="text-center">
                  <strong> Expiring in two weeks </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiredPromos(
                    selected_from_all_clients.registrar_id
                      ? selected_from_all_clients.registrar_id
                      : selected_from_all_clients.reseller_id,
                    selected_from_all_clients.registrar_id
                      ? 'registrar'
                      : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expired
                  "
                  style="background: rgba(var(--vs-danger), 0.1)"
                  >{{ selected_from_all_clients.expiredCount }}</small
                >
                <div class="text-center"><strong> Expired </strong></div>
              </div>

              <div
                class="
                  mx-5
                  py-5
                  text-center
                  reset-filter
                  expiring-promo-count--action-btn
                "
                @click="resetFilters()"
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    reset-icon
                  "
                  style="background: rgba(var(--vs-primary), 0.1)"
                >
                  <strong
                    ><feather-icon
                      icon="RotateCwIcon"
                      :svgClasses="`h-4 w-4 mt-1`"
                  /></strong>
                </small>
                <div class="text-center reset-text">
                  <strong> Reset </strong>
                </div>
              </div>

              <div class="py-5 ml-auto justify-center flex items-center">
                <vs-button
                  color="primary"
                  type="filled"
                  class="action-btn mr-3"
                  @click="addAgreements(client_id)"
                  >Add Agreement</vs-button
                >
                <vs-button
                  color="primary"
                  type="border"
                  class="action-btn"
                  @click="viewAgreements(client_id)"
                  >View Agreements</vs-button
                >
              </div>
            </div>
            <vs-collapse>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">CNIC Promos</div>
                <CnicPromoClientComponent
                  :registrarid="
                    this.selected_from_all_clients.registrar_id
                      ? this.selected_from_all_clients.registrar_id
                      : null
                  "
                  :filteredData="filteredCNICData"
                ></CnicPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">
                  Internal Promos
                </div>
                <InternalPromoClientComponent
                  :resellerid="
                    this.selected_from_all_clients.reseller_id
                      ? this.selected_from_all_clients.reseller_id
                      : null
                  "
                  :filteredData="filteredInternalData"
                ></InternalPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">MIS</div>
                <MisPromoClientComponent
                  :resellerid="
                    this.selected_from_all_clients.reseller_id
                      ? this.selected_from_all_clients.reseller_id
                      : null
                  "
                  :filteredData="filteredMISData"
                ></MisPromoClientComponent>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>
      </vs-tabs>
      <!-- Tabs on the top -->

      <!-- If no favourite clients are added -->
      <vs-tabs
        v-show="favouriteClients.length == 0"
        class="custom-vs-tabs clients-page slot-border-top empty-data-tab"
      >
        <vs-tab label="">
          <div class="tab-text">
            <div class="expiring-promo-count flex mx-5">
              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="expiringInAWeekPromos(null, null)"
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-week
                  "
                  style="background: rgba(var(--vs-warning), 0.1)"
                  >0</small
                >
                <div class="text-center">
                  <strong> Expiring in a week </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="expiringInTwoWeeksPromos(null, null)"
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-two-weeks
                  "
                  style="background: rgba(var(--vs-primary), 0.1)"
                  >0</small
                >
                <div class="text-center">
                  <strong> Expiring in two weeks </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="expiredPromos(null, null)"
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expired
                  "
                  style="background: rgba(var(--vs-danger), 0.1)"
                  >0</small
                >
                <div class="text-center"><strong> Expired </strong></div>
              </div>

              <div
                class="
                  mx-5
                  py-5
                  text-center
                  reset-filter
                  expiring-promo-count--action-btn
                "
                @click="resetFilters()"
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    reset-icon
                  "
                  style="background: rgba(var(--vs-primary), 0.1)"
                >
                  <strong
                    ><feather-icon
                      icon="RotateCwIcon"
                      :svgClasses="`h-4 w-4 mt-1`"
                  /></strong>
                </small>
                <div class="text-center reset-text">
                  <strong> Reset </strong>
                </div>
              </div>

              <div class="py-5 ml-auto justify-center flex items-center">
                <vs-button
                  color="primary"
                  type="filled"
                  class="action-btn mr-3"
                  @click="addAgreements(null)"
                  >Add Agreement</vs-button
                >
                <vs-button
                  color="primary"
                  type="border"
                  class="action-btn"
                  @click="viewAgreements(null)"
                  >View Agreements</vs-button
                >
              </div>
            </div>
            <vs-collapse>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">CNIC Promos</div>
                <CnicPromoClientComponent
                  :registrarid="null"
                  :filteredData="filteredCNICData"
                ></CnicPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">
                  Internal Promos
                </div>
                <InternalPromoClientComponent
                  :resellerid="null"
                  :filteredData="filteredInternalData"
                ></InternalPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">MIS</div>
                <MisPromoClientComponent
                  :resellerid="null"
                  :filteredData="filteredMISData"
                ></MisPromoClientComponent>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>

        <vs-tab label="" id="clients-tab-no-fav-added">
          <div class="tab-text">
            <div class="expiring-promo-count flex mx-5">
              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiringInAWeekPromos(
                    selected_from_all_clients.registrar_id
                      ? selected_from_all_clients.registrar_id
                      : selected_from_all_clients.reseller_id,
                    selected_from_all_clients.registrar_id
                      ? 'registrar'
                      : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-week
                  "
                  style="background: rgba(var(--vs-warning), 0.1)"
                  >{{ selected_from_all_clients.expiringInAWeekCount }}</small
                >
                <div class="text-center">
                  <strong> Expiring in a week </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiringInTwoWeeksPromos(
                    selected_from_all_clients.registrar_id
                      ? selected_from_all_clients.registrar_id
                      : selected_from_all_clients.reseller_id,
                    selected_from_all_clients.registrar_id
                      ? 'registrar'
                      : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expiring-in-two-weeks
                  "
                  style="background: rgba(var(--vs-primary), 0.1)"
                  >{{
                    selected_from_all_clients.expiringInTwoWeeksCount
                  }}</small
                >
                <div class="text-center">
                  <strong> Expiring in two weeks </strong>
                </div>
              </div>

              <div
                class="mx-5 py-5 text-center expiring-promo-count--action-btn"
                @click="
                  expiredPromos(
                    selected_from_all_clients.registrar_id
                      ? selected_from_all_clients.registrar_id
                      : selected_from_all_clients.reseller_id,
                    selected_from_all_clients.registrar_id
                      ? 'registrar'
                      : 'reseller'
                  )
                "
              >
                <small
                  class="
                    mb-2
                    w-10
                    h-10
                    inline-flex
                    items-center
                    justify-center
                    rounded-lg
                    text-dark
                    expired
                  "
                  style="background: rgba(var(--vs-danger), 0.1)"
                  >{{ selected_from_all_clients.expiredCount }}</small
                >
                <div class="text-center"><strong> Expired </strong></div>
              </div>

              <div class="
                  mx-5
                  py-5
                  text-center
                  reset-filter
                  expiring-promo-count--action-btn"
                @click="resetFilters()">
                <small
                  class="
                  mb-2
                  w-10
                  h-10
                  inline-flex
                  items-center
                  justify-center
                  rounded-lg
                  text-dark
                  reset-icon"
                  style="background: rgba(var(--vs-primary), 0.1)">
                  <strong><feather-icon
                    icon="RotateCwIcon"
                    :svgClasses="`h-4 w-4 mt-1`" /></strong>
                </small>
                <div class="text-center reset-text">
                  <strong> Reset </strong>
                </div>
              </div>

              <div class="py-5 ml-auto justify-center flex items-center">
                <vs-button
                  color="primary"
                  type="filled"
                  class="action-btn mr-3"
                  @click="addAgreements(client_id)">
                  Add Agreement</vs-button>
                <vs-button
                  color="primary"
                  type="border"
                  class="action-btn"
                  @click="viewAgreements(client_id)">
                  View Agreements</vs-button>
              </div>
            </div>
            <vs-collapse>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">CNIC Promos</div>
                <CnicPromoClientComponent
                  :registrarid="
                    this.selected_from_all_clients.registrar_id
                      ? this.selected_from_all_clients.registrar_id
                      : null
                  "
                  :filteredData="filteredCNICData"
                ></CnicPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">
                  Internal Promos
                </div>
                <InternalPromoClientComponent
                  :resellerid="
                    this.selected_from_all_clients.reseller_id
                      ? this.selected_from_all_clients.reseller_id
                      : null
                  "
                  :filteredData="filteredInternalData"
                ></InternalPromoClientComponent>
              </vs-collapse-item>
              <vs-collapse-item open>
                <div slot="header" class="promo-type-header">MIS</div>
                <MisPromoClientComponent
                  :resellerid="
                    this.selected_from_all_clients.reseller_id
                      ? this.selected_from_all_clients.reseller_id
                      : null
                  "
                  :filteredData="filteredMISData"
                ></MisPromoClientComponent>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-tab>
      </vs-tabs>
      <!-- If no favourite clients are added -->

      <!-- Fav Clients & All Clients dropdowns -->
      <div
        class="client-fav-dropdowns"
        :class="!favouriteClients.length ? 'opacity-100 left-0' : ''"
      >
        <div v-if="!favouriteClients.length" class="add-client-title">
          Add your favourite clients
        </div>
        <div
          class="fav-client-wrap"
          :class="this.showFavClients ? 'isActive' : ''"
        >
          <label
            class="inline-flex cursor-pointer"
            @click="showFavClients = !showFavClients"
            ><vs-icon
              color="primary"
              icon-pack="feather"
              icon="icon-plus"
              class=""
          /></label>

          <!-- <treeselect
            v-if="showFavClients"
            :multiple="true"
            :options="clientOptions"
            :flat="true"
            :sort-value-by="sortValueBy"
            :default-expand-level="1"
            :always-open="alwaysOpen"
            class=""
            placeholder=""
            v-model="fav_client_ids"
            :clearable="true"
            @input="handeTreeSelect"
          /> -->

          <treeselect v-if="showFavClients" name="client" class="" v-model="fav_client_ids" :async="true" :load-options="clientSearchOptions" :multiple="true" :flat="true" :sort-value-by="sortValueBy" :default-expand-level="1" :clearable="true" placeholder="" @input="handeTreeSelect" :always-open="alwaysOpen" />

          <div v-if="showFavClients" class="fav-client-count">
            Add Client Shortcuts ({{ this.selected_fav_clients }}/5)
          </div>
          <div
            v-if="showFavClients"
            class="send-fav-client-btn"
            @click="sendFavClients()"
          >
            Done
          </div>
        </div>

        <div class="vx-col w-full form-field">
          <!-- <treeselect
            :multiple="false"
            :options="clientOptions"
            :flat="true"
            :sort-value-by="sortValueBy"
            :default-expand-level="1"
            class="w-full all-client-dropdown"
            placeholder="All Clients"
            v-model="client_id"
            :clearable="true"
          /> -->

          <treeselect name="client" class="w-full all-client-dropdown" v-model="client_id" :async="true" :load-options="clientSearchOptions" :multiple="false" :flat="true" :sort-value-by="sortValueBy" :default-expand-level="1" :clearable="true" placeholder="All Clients" />
        </div>
      </div>
      <!-- Fav Clients & All Clients dropdowns -->

      <!-- Fav Clients capped message -->
      <div>
        <vs-popup
          class="client-count-popup"
          classContent="popup-example"
          title=""
          :active.sync="alertFavClientCountPopup"
        >
          <div>You can only add 5 clients in favourites.</div>
        </vs-popup>
      </div>
      <!-- Fav Clients capped message -->
    </div>

    <EditCnicPromo></EditCnicPromo>

    <EditInternalPromo></EditInternalPromo>

    <EditMISPromo></EditMISPromo>

    <UploadAgreement></UploadAgreement>
  </div>
</template>

<script>
import CnicPromoClientComponent from "@/components/ag-grid-tables/CnicPromoClientComponent.vue";
import InternalPromoClientComponent from "@/components/ag-grid-tables/InternalPromoClientComponent.vue";
import MisPromoClientComponent from "@/components/ag-grid-tables/MISPromoClientComponent.vue";

import EditCnicPromo from "@/components/ag-grid-tables/promos/EditCNICPromo.vue";
import EditInternalPromo from "@/components/ag-grid-tables/promos/EditInternalPromo.vue";
import EditMISPromo from "@/components/ag-grid-tables/promos/EditMISPromo.vue";

import UploadAgreement from "@/components/UploadAgreement.vue";

import Treeselect from "@riophae/vue-treeselect";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";


export default {
  components: {
    CnicPromoClientComponent,
    InternalPromoClientComponent,
    MisPromoClientComponent,
    EditCnicPromo,
    EditInternalPromo,
    EditMISPromo,
    UploadAgreement,
    Treeselect,
  },

  data() {
    return {
      favouriteClients: [],
      alertFavClientCountPopup: false,
      fav_client_ids: null,
      selected_fav_clients: "0",
      getSelectedClient: [],
      selectedRegId: [],
      selectedResellerId: [],
      selected_from_all_clients: {
        registrar_id: null,
        reseller_id: null,
        expiringInAWeekCount: "0",
        expiringInTwoWeeksCount: "0",
        expiredCount: "0",
      },
      client_id: null,
      reseller_id: null,
      registrar_id: null,
      registrar_name: null,
      sortValueBy: "ORDER_SELECTED",
      showClients: false,
      showFavClients: false,
      alwaysOpen: true,
      tabSelected: false,
      filteredCNICData: null,
      filteredInternalData: null,
      filteredMISData: null,
      active_client: -1,
    };
  },

  computed: {
    user_details() {
      return JSON.parse(localStorage.getItem('userDetails'))
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    // NOTE: Vuex master data fetch
    clientOptions() {
      // return this.$store.getters.setClientOptions;
      return this.$store.getters.getClientOptions;
    },
  },

  beforeMount() {
    this.getFavouriteClients();
  },

  watch: {
    client_id(val) {
      var ul = document.getElementsByClassName("ul-tabs")[0].clientWidth;
      if (val) {
        if (document.getElementById("clients-tab")) {
          document.getElementById("clients-tab").click();
        } else {
          document.getElementById("clients-tab-no-fav-added").click();
        }

        this.tabSelected = false;
        val = val.split("-");
        this.selected_from_all_clients.registrar_id = null;
        this.selected_from_all_clients.reseller_id = null;
        if (val[0] === "CNIC") {
          this.selected_from_all_clients.registrar_id = parseInt(val[1]);
          this.getExpiringCounts(
            "registrar",
            this.selected_from_all_clients.registrar_id
          )
            .then((expiringCounts) => {
              this.selected_from_all_clients["expiringInAWeekCount"] =
                expiringCounts.expiringInAWeekCount;
              this.selected_from_all_clients["expiringInTwoWeeksCount"] =
                expiringCounts.expiringInTwoWeeksCount;
              this.selected_from_all_clients["expiredCount"] =
                expiringCounts.expiredCount;
            })
            .catch((error) => {
              throw error;
            });
        } else {
          this.selected_from_all_clients.reseller_id = parseInt(val[1]);
          this.getExpiringCounts(
            "reseller",
            this.selected_from_all_clients.reseller_id
          )
            .then((expiringCounts) => {
              this.selected_from_all_clients["expiringInAWeekCount"] =
                expiringCounts.expiringInAWeekCount;
              this.selected_from_all_clients["expiringInTwoWeeksCount"] =
                expiringCounts.expiringInTwoWeeksCount;
              this.selected_from_all_clients["expiredCount"] =
                expiringCounts.expiredCount;
            })
            .catch((error) => {
              throw error;
            });
        }
      } else {
        if (!this.tabSelected) {
          var ul = document.getElementsByClassName("ul-tabs")[0];
          ul.firstElementChild
            .getElementsByClassName("vs-tabs--btn")[0]
            .click();
        }
        this.selected_from_all_clients.registrar_id = null;
        this.selected_from_all_clients.reseller_id = null;

        this.filteredCNICData = null;
        this.filteredInternalData = null;
        this.filteredMISData = null;
      }
    },
    // NOTE: Vuex master data fetch
    clientOptions() {
      // return this.$store.getters.setClientOptions;
      return this.$store.getters.getClientOptions;
    },
  },

  mounted() {
    // NOTE: Before Vuex usage
    // this.setClientOptions();
    // NOTE: Click outside event for Add Fav Client dropdown
    var container = document.getElementsByClassName("fav-client-wrap")[0],
      self = this;
    document.addEventListener("click", function (event) {
      if (
        container !== event.target &&
        !container.contains(event.target) &&
        self.showFavClients
      ) {
        self.showFavClients = false;
      }
    });
  },

  methods: {
    clientSearchOptions({ action, searchQuery, callback }) {
        if (action === ASYNC_SEARCH) {
            this.$axiosSecure.get(`/v2/unique-registrars/${searchQuery}`)
            .then(response => {
                let clientsList = response.data;

                var transformedClientsList = [];

                for (var client of clientsList) {
                    var temp = {
                        id:
                            "CNIC-" +
                            client["id"] +
                            "-" +
                            client["country_id"] +
                            "-" +
                            client["name"],
                        label: client["name"],
                        isDisabled: this.user_details.role == "channel_user" ? ((client["unique_registrar_client_am"] && client["unique_registrar_client_am"].length && client["unique_registrar_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(client["unique_registrar_client_am"][0]["user_id"]) == -1) : false,
                        children: client["new_reseller"].length ? [] : undefined,
                        new_registrar: client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }})
                    };

                    if (client["new_reseller"].length) {
                        // Push resellers into obj
                        for (var reseller of client["new_reseller"]) {
                            temp["children"].push({
                                id:
                                    reseller["name"] === client["name"]
                                        ? "PROMO-" +
                                        reseller["id"] +
                                        "-" +
                                        client["id"] +
                                        "-" +
                                        "SAME-" +
                                        client["country_id"] +
                                        "-" +
                                        reseller["name"]
                                        : "PROMO-" +
                                        reseller["id"] +
                                        "-" +
                                        client["id"] +
                                        "-" +
                                        reseller["name"],
                                label: reseller["name"],
                                isDisabled: this.user_details.role == "channel_user" ? ((reseller["new_reseller_client_am"] && reseller["new_reseller_client_am"].length && reseller["new_reseller_client_am"][0]["user_id"]) && this.user_details.associated_users && this.user_details.associated_users.length && this.user_details.associated_users.indexOf(reseller["new_reseller_client_am"][0]["user_id"]) == -1) : false,
                                new_registrar: reseller["name"] === client["name"] ? client.new_registrar.map(x => { return { value: x.id, label: client.name, cnic_id: x.cnic_id, unique_registrar_id: client["id"] }}) : []
                            });
                        }
                    }

                    transformedClientsList.push(temp);
                }

                callback(null, transformedClientsList);
            })
            .catch(error => {
                console.log("Entity Search Error", error);
            })
        }
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },

    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },

    checkTabsWidth() {
      setTimeout(() => {
        var tabsWidth =
          document.getElementsByClassName("ul-tabs")[0].clientWidth + 20;
        document.getElementsByClassName("client-fav-dropdowns")[0].style.left =
          tabsWidth + "px";
        document.getElementsByClassName(
          "client-fav-dropdowns"
        )[0].style.opacity = "1";
      }, 200);
    },

    handeTreeSelect(data) {
      this.selected_fav_clients = this.fav_client_ids.length;
      // console.log('data', data);
      this.getSelectedClient = data;
      if (data.length > 5) {
        this.fav_client_ids.length = 5;
        this.alertFavClientCountPopup = true;
      }
    },

    sendFavClients() {
      var dataSplit = this.getSelectedClient.map((x) => x.split("-"));
      this.showFavClients = !this.showFavClients;
      (this.selectedRegId = []), (this.selectedResellerId = []);
      dataSplit.forEach((el) => {
        // console.log(el);
        if (el[0] === "CNIC") {
          this.selectedRegId.push(el[1]);
        } else {
          this.selectedResellerId.push(el[1]);
        }
      });
      this.openLoadingInDiv();
      this.$axiosSecure
        .post("/favourite-clients", {
          user_id: this.user_id,
          unique_registrars: this.selectedRegId,
          new_resellers: this.selectedResellerId,
        })
        .then((response) => {
          // console.log('done', response.data);
          this.getFavouriteClients();
          setTimeout(() => {
            this.hideLoadingInDiv();
          }, 900);
        })
        .catch((error) => {
          // console.log(error);
          this.hideLoadingInDiv();
        });
    },

    getFavouriteClients() {
      this.favouriteClients = [];

      var userid = this.user_id;

      // Get clients
      this.$axiosSecure
        .get(`/favourite-clients/${userid}`)

        .then((response) => {
          response.data.map((re) => {
            re["expiringInAWeekCount"] = 0;
            re["expiringInTwoWeeksCount"] = 0;
            re["expiredCount"] = 0;
          });

          this.favouriteClients = response.data;
          var checkedFavIds = [];
          this.favouriteClients.forEach((x) => {
            if (x.unique_registrar) {
              var formatCNICId =
                "CNIC-" +
                x.unique_registrar_id +
                "-" +
                x.unique_registrar.country_id +
                "-" +
                x.unique_registrar.name;
              checkedFavIds.push(formatCNICId);
              this.getExpiringCounts("unique_registrar", x.unique_registrar_id)
                .then((expiringCounts) => {
                  // console.log("expiringCounts :>> ", expiringCounts);
                  x["expiringInAWeekCount"] =
                    expiringCounts.expiringInAWeekCount;
                  x["expiringInTwoWeeksCount"] =
                    expiringCounts.expiringInTwoWeeksCount;
                  x["expiredCount"] = expiringCounts.expiredCount;
                })
                .catch((error) => {
                  throw error;
                });
            } else {
              if (x.new_reseller.name === x.new_reseller.unique_registrar.name) {
                var fillerData = "-SAME-" + x.new_reseller.country_id + "-";
                this.getExpiringCounts("reseller", x.new_reseller_id)
                  .then((expiringCounts) => {
                    // console.log("expiringCounts :>> ", expiringCounts);
                    x["expiringInAWeekCount"] =
                      expiringCounts.expiringInAWeekCount;
                    x["expiringInTwoWeeksCount"] =
                      expiringCounts.expiringInTwoWeeksCount;
                    x["expiredCount"] = expiringCounts.expiredCount;
                  })
                  .catch((error) => {
                    throw error;
                  });
              } else {
                var fillerData = "-";
              }
              var formatPromoId =
                "PROMO-" +
                x.reseller_id +
                "-" +
                x.new_reseller.unique_registrar_id +
                fillerData +
                x.new_reseller.name;
              checkedFavIds.push(formatPromoId);
            }
            this.fav_client_ids = checkedFavIds;
            this.selected_fav_clients = this.fav_client_ids.length;
            this.checkTabsWidth();
          });
        })
        .catch((error) => {
          // Error notification
          this.$vs.notify({
            color: "danger",
            title: "Something went wrong",
            text: "Please contact the server admin",
          });
          console.log(error);
        });
    },

    getExpiringCounts(type, client_id) {
      return new Promise((resolve, reject) => {
        this.$axiosSecure
          .get(`/expiring-expired-count/${client_id}?type=${type}`)

          .then((response) => {
            resolve({
              expiringInAWeekCount: response.data.oneweek,
              expiringInTwoWeeksCount: response.data.twoweeks,
              expiredCount: response.data.expired,
            });
          })
          .catch((error) => {
            // Error notification
            this.$vs.notify({
              color: "danger",
              title: "Something went wrong",
              text: "Please contact the server admin",
            });
            console.log(error);
            reject(error);
          });
      });
    },
    
    switchToTabs() {
      this.tabSelected = true;
      this.client_id = null;
    },

    addAgreements(id) {
      this.$root.$emit("openAgtPopup", id);
    },

    viewAgreements(clientId) {
      this.$router.push({
        name: "Agreements",
        params: { client_id: clientId },
      });
    },
    
    // Expiring count buttons action
    expiringInAWeekPromos(client_id, type) {
      if (client_id && type) {
        this.$axiosSecure
          .get(`/expiring-in-a-week/${client_id}?type=${type}`)
          .then((response) => {
            if (type == "registrar") {
              this.filteredCNICData = response.data.cnic_data
                ? response.data.cnic_data
                : [];
            } else {
              this.filteredInternalData = response.data.local_promo_data
                ? response.data.local_promo_data
                : [];
              this.filteredMISData = response.data.mis_data
                ? response.data.mis_data
                : [];
            }
          });
      }
    },

    expiringInTwoWeeksPromos(client_id, type) {
      if (client_id && type) {
        this.$axiosSecure
          .get(`/expiring-in-two-weeks/${client_id}?type=${type}`)
          .then((response) => {
            if (type == "registrar") {
              this.filteredCNICData = response.data.cnic_data
                ? response.data.cnic_data
                : [];
            } else {
              this.filteredInternalData = response.data.local_promo_data
                ? response.data.local_promo_data
                : [];
              this.filteredMISData = response.data.mis_data
                ? response.data.mis_data
                : [];
            }
          });
      }
    },

    expiredPromos(client_id, type) {
      if (client_id && type) {
        this.$axiosSecure
          .get(`/expired/${client_id}?type=${type}`)
          .then((response) => {
            if (type == "registrar") {
              this.filteredCNICData = response.data.cnic_data
                ? response.data.cnic_data
                : [];
            } else {
              this.filteredInternalData = response.data.local_promo_data
                ? response.data.local_promo_data
                : [];
              this.filteredMISData = response.data.mis_data
                ? response.data.mis_data
                : [];
            }
          });
      }
    },

    resetFilters() {
      this.filteredCNICData = null;
      this.filteredInternalData = null;
      this.filteredMISData = null;
    },
  },

  beforeDestroy() {
    if (this.$refs.vsCollapseItem) {
      for (let collapseItem of this.$refs.vsCollapseItem) {
        window.removeEventListener("resize", collapseItem);
      }
    }
  },
};
</script>

<style>
/* .vs-collapse-item--header {
  padding: 0 !important;
} */

.expiring-in-week,
.expiring-in-two-weeks,
.expired {
  font-weight: bold;
  font-size: 14px;
}

.reset-filter {
  padding: 1rem;
}

.reset-filter::before {
  content: "";
  height: 75px;
  width: 1px;
  position: absolute;
  top: 9px;
  background: #d1d1d1;
}

.reset-icon,
.reset-text {
  margin-left: 3rem;
}

.vs-tabs--content {
  padding: 0;
}

.client-fav-dropdowns {
  display: flex;
  position: absolute;
  top: 0px;
  opacity: 0;
}

.fav-client-wrap {
  position: relative;
  margin: 0px 8px;
  padding: 10px 13px;
  display: inline-flex;
  height: 30px;
}

.fav-client-wrap.isActive {
  background: #d5d5d5;
}

.fav-client-wrap:before {
  content: "";
  background: #d1d1d1;
  height: 20px;
  width: 1px;
  position: absolute;
  top: 7px;
  right: 0;
}
.fav-client-wrap .vue-treeselect {
  position: absolute;
  right: 0;
  width: 200px;
  top: 100%;
}

.fav-client-count {
  position: absolute;
  width: 200px;
  right: 0;
  top: 100%;
  background: #d5d5d5;
  color: #000;
  font-family: "Work Sans", sans-serif;
  letter-spacing: -0.75px;
  padding: 5px 8px;
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
}

.fav-client-wrap .vue-treeselect {
  top: calc(100% + 63px);
}

.expiring-promo-count strong {
  color: #000;
  font-family: "Work Sans", sans-serif;
  font-weight: 600;
  letter-spacing: -0.75px;
}

.expiring-promo-count--action-btn {
  cursor: pointer;
}

.send-fav-client-btn {
  background: #0142f7;
  color: #fff;
  font-family: "Work Sans", sans-serif;
  font-weight: 500;
  letter-spacing: -0.65px;
  position: absolute;
  top: calc(100% + 30px);
  width: 200px;
  right: 0;
  text-align: center;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
}
.all-client-dropdown .vue-treeselect__control {
  border-color: transparent !important;
}
.all-client-dropdown .vue-treeselect__placeholder {
  color: #939393;
}
.all-client-dropdown.vue-treeselect--has-value {
  position: relative;
}
.all-client-dropdown.vue-treeselect--has-value::before {
  content: "";
  background: linear-gradient(30deg,rgba(var(--vs-primary), 1),rgba(var(--vs-primary), 0.5)) !important;
  height: 2px;
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
}
#fav-client-tabs .ul-tabs {
  display: inline-flex !important;
  width: auto;
}
#fav-client-tabs .ul-tabs li:last-child {
  padding: 0;
}
</style>